// @ts-check

import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import persist from '@alpinejs/persist';
import focus from '@alpinejs/focus';
import { HeaderGroupManager } from './header-group';

// @ts-expect-error Alpine is a global
window.Alpine = Alpine;
Alpine.store('settings', {
  // @ts-expect-error BRANCHNAME is a global
  branchName: BRANCHNAME,
  // @ts-expect-error GITUSER is a global
  gitUser: GITUSER,
  isProd: process.env.NODE_ENV === 'production'
});
Alpine.store('headerGroupManager', HeaderGroupManager.getInstance());

// TODO: Move this into PDP JS
Alpine.data('pdpDialog', function () {
  return {
    selectedIndex: 0,
    showPdpDialog: false,
    /**
     * open dialog and set selected index
     * @param {Event} $event
     */
    openDialog: function openDialog($event) {
      var _this = this;
      this.showPdpDialog = true;
      var target = $event.target;
      if (!(target instanceof HTMLElement)) return;
      this.selectedIndex = parseInt(target.dataset.index || '0', 10);
      var pdpMedia = target.closest('.product__media');
      if (!pdpMedia) return;
      var dialog = pdpMedia.querySelector('dialog');
      if (!dialog) return;
      dialog.showModal();
      this.$nextTick(function () {
        var _this$$refs$modalClos;
        return (_this$$refs$modalClos = _this.$refs.modalClose) === null || _this$$refs$modalClos === void 0 ? void 0 : _this$$refs$modalClos.focus();
      });
      document.body.classList.add('overflow-hidden');
      // console.log(this.selectedIndex)
      this.scrollMediaIntoView(dialog);
    },
    /**
     * scroll the selected media element into view
     * @param {HTMLDialogElement} element
     */
    scrollMediaIntoView: function scrollMediaIntoView(element) {
      var selectedElement = element.querySelectorAll('[data-dialog-media]')[this.selectedIndex];
      // console.log(selectedElement)
      this.$nextTick(function () {
        if (selectedElement) {
          selectedElement.scrollIntoView({
            behavior: 'auto',
            block: 'center',
            inline: 'center'
          });
        }
      });
    }
  };
});
Alpine.plugin(collapse);
Alpine.plugin(persist);
Alpine.plugin(focus);
Alpine.start();